// Buyer phone numbers — normalizer + validity rule shared by the storefront
// (checkout forms, order submission) and the prodpanel (order dialog).
//
// KEEP IN SYNC with terbebas-backend/src/service/phone.service.ts: the
// backend flags orders / rejects addresses with the identical logic, so a
// number a form accepts is never flagged server-side, and vice versa.
//
// "Mobile only" on purpose: the number feeds KiriminAja pickups and
// WhatsApp, both of which need an Indonesian mobile (08xx).
// Digits only, strip every leading "0" / "62", then prefix "62". Returns ''
// for an empty input — never a bare "62" (the bug behind orders stored with
// phone "62").
export function normalizeIndonesianPhone(raw) {
    // String(): number-typed form fields (type="number") hand over a Number.
    var digits = String(raw !== null && raw !== void 0 ? raw : '').replace(/[^\d]/g, '');
    // (indexOf/charAt: common-ts compiles to ES5 without the ES2015 lib.)
    while (digits.charAt(0) === '0' || digits.indexOf('62') === 0) {
        digits = digits.indexOf('62') === 0 ? digits.substring(2) : digits.substring(1);
    }
    return digits ? '62' + digits : '';
}
// A normalized Indonesian mobile: 62 + 8 + 8..11 more digits (local part
// 9–12 digits).
export var INDONESIAN_MOBILE_RE = /^628\d{8,11}$/;
export function isValidIndonesianMobile(normalized) {
    return INDONESIAN_MOBILE_RE.test(normalized);
}
// Normalize-then-validate in one step, for raw user input.
export function isValidIndonesianPhoneInput(raw) {
    return isValidIndonesianMobile(normalizeIndonesianPhone(raw));
}
// First candidate that is a valid mobile, normalized; undefined when none.
export function firstValidPhone(candidates) {
    for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
        var candidate = candidates_1[_i];
        var normalized = normalizeIndonesianPhone(candidate);
        if (isValidIndonesianMobile(normalized))
            return normalized;
    }
    return undefined;
}
